import $ from 'jquery';

const API_SRC = 'https://www.youtube.com/iframe_api';

// Loads the YouTube IFrame API once, chaining onto any existing ready callback
// so a second consumer on the page can't clobber ours.
function loadApi() {
    return new Promise((resolve) => {
        if (window.YT && window.YT.Player) {
            resolve();

            return;
        }

        const previous = window.onYouTubeIframeAPIReady;

        window.onYouTubeIframeAPIReady = () => {
            if (typeof previous === 'function') {
                previous();
            }

            resolve();
        };

        if (!document.querySelector(`script[src="${API_SRC}"]`)) {
            const tag = document.createElement('script');

            tag.src = API_SRC;

            document.head.appendChild(tag);
        }
    });
}

// Drives the hero's background YouTube player through the IFrame API. YouTube has
// no chromeless mode, so URL params alone can't stop its controls flashing on
// loop or refocus - the API lets us loop in place and only reveal once playing.
export default class HeroVideo {
    constructor() {
        const $iframes = $('.js-hero-video');

        if (!$iframes.length) {
            return;
        }

        loadApi().then(() => {
            $iframes.each((index, el) => this.initPlayer(el, index));
        });
    }

    initPlayer(el, index) {
        const videoId = el.dataset.videoId;

        if (!videoId) {
            return;
        }

        el.id = el.id || `js-hero-video-${index}`;

        // Keep a handle to the wrapper before the API swaps the placeholder div
        // for its own iframe - `el` is gone after that, the wrapper stays.
        const $wrapper = $(el).closest('.js-hero-video-wrapper');

        new window.YT.Player(el, {
            videoId,
            playerVars: {
                autoplay: 1,
                mute: 1,
                controls: 0,
                playsinline: 1,
                modestbranding: 1,
                rel: 0,
                disablekb: 1,
                fs: 0,
                iv_load_policy: 3,
            },
            events: {
                onReady: (event) => {
                    // Keep the API-built iframe out of the tab order so a focus
                    // change can't make YouTube surface its chrome. (Doesn't stop
                    // the transient state-indicator YouTube shows on play/refocus -
                    // that's not suppressible; Vimeo is the chromeless path.)
                    event.target.getIframe().setAttribute('tabindex', '-1');
                    event.target.mute();
                    event.target.playVideo();
                },
                onStateChange: (event) => {
                    const { PLAYING, ENDED } = window.YT.PlayerState;

                    // Reveal only once it's genuinely playing - masks the controls
                    // and title that flash during the muted-autoplay handshake.
                    if (event.data === PLAYING) {
                        $wrapper.addClass('is-playing');
                    }

                    // Restart in place rather than letting native loop reload the
                    // player, which is what flashed the controls on every loop.
                    if (event.data === ENDED) {
                        event.target.seekTo(0);
                        event.target.playVideo();
                    }
                },
            },
        });
    }
}
